import { render, staticRenderFns } from "./AllowedSelect.vue?vue&type=template&id=6d10d4e3&"
import script from "./AllowedSelect.vue?vue&type=script&lang=js&"
export * from "./AllowedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports